import { render } from "./AssignDriver.vue?vue&type=template&id=767d8fca"
import script from "./AssignDriver.vue?vue&type=script&lang=ts"
export * from "./AssignDriver.vue?vue&type=script&lang=ts"
script.render = render

export default script